import { i18n } from '@/lib/i18n';

// Leasing is closer to renting, so lease estates use the rental price fields like rent
const RENTAL_MARKET_TYPES = new Set(['rent', 'lease']);

export const isRentalMarketType = (marketType?: string | null) =>
  RENTAL_MARKET_TYPES.has(marketType ?? '');

export const getPriceNumber = (value?: string | number | null) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const getPriceNumberWithDefault = (
  value: string | number | null | undefined,
  fallback: number
) => {
  if (value === null || value === undefined || value === '') return fallback;
  return getPriceNumber(value);
};

export const getInclVatValue = (
  value?: string | number | null,
  vatValue?: string | number | null
) => {
  const amount = getPriceNumber(value);
  const vat = getPriceNumber(vatValue);
  return amount + (amount * vat) / 100;
};

export const hasPriceValue = (value?: string | number | null) =>
  value !== undefined && value !== null && value !== '';

export const formatPriceValue = (
  value?: string | number | null,
  currency: string = 'EUR',
  minimumFractionDigits = 2,
  locale: string = i18n.language === 'en' ? 'en-US' : 'de-DE'
) => {
  if (!hasPriceValue(value)) return '';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits: 2,
  }).format(getPriceNumber(value));
};

export const formatPercentValue = (value?: string | number | null) => {
  if (!hasPriceValue(value)) return '';
  return `${getPriceNumber(value).toFixed(2)}%`;
};

export const formatDateValue = (value?: string | number | null) => {
  if (!hasPriceValue(value)) return '';
  const date = new Date(String(value));
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(i18n.language === 'en' ? 'en-US' : 'de-DE').format(date);
};
